import { render, staticRenderFns } from "./BranchesConfig.vue?vue&type=template&id=400557a7"
import script from "./BranchesConfig.vue?vue&type=script&lang=js"
export * from "./BranchesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports